import { render, staticRenderFns } from "./OrderQuery.vue?vue&type=template&id=1be4c270&scoped=true&"
import script from "./OrderQuery.vue?vue&type=script&lang=js&"
export * from "./OrderQuery.vue?vue&type=script&lang=js&"
import style0 from "./OrderQuery.vue?vue&type=style&index=0&id=1be4c270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be4c270",
  null
  
)

export default component.exports